// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6814da25","455":"195032ae","977":"bb481d2b"}[chunkId] + ".chunk.js";
};